
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetosaneteenshaktipeeth() {



    const cardData =
    {
        keyword: 'Pune To Sade Teen Shakti Peeth Cab',
        heading: 'Mauli Cabs: Pune To Sade Teen Shakti Peeth Cab',
        headingDescription: 'Mauli Cabs offers dependable and comfortable Pune to Sade Teen Shakti Peeth cab services, ensuring a smooth and spiritual journey to these sacred Shakti Peeths. Whether you are embarking on a pilgrimage, a family trip, or a peaceful retreat, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a focus on safety, Mauli Cabs guarantees a hassle-free and enriching experience on your Sade Teen Shakti Peeth journey.',

        top: 'Top Places to Visit in Aurangabad with Mauli Cabs',

"topPlaces": [
    {
        "title": "Mahalaxmi Temple (Kolhapur)",
        "description": "Mahalaxmi Temple in Kolhapur is one of the most revered Shakti Peethas in India. It is dedicated to Goddess Mahalaxmi, the goddess of wealth, and is believed to be the place where her right breast fell. The temple's architecture and the idol of the goddess are truly mesmerizing."
    },
    {
        "title": "Kamakshi Temple (Kolhapur)",
        "description": "Kamakshi Temple, also located in Kolhapur, is another important Shakti Peetha. This temple is dedicated to Goddess Kamakshi, and it is believed that her right eye fell here. The temple is known for its serene ambiance and spiritual significance."
    },
    {
        "title": "Bhavani Temple (Tuljapur)",
        "description": "Bhavani Temple in Tuljapur is another important Shakti Peetha and a major pilgrimage site in Maharashtra. The temple is dedicated to Goddess Bhavani, and it is believed that her right leg fell here. The temple attracts devotees seeking blessings for strength and prosperity."
    },
    {
        "title": "Saptashrungi Temple (Nashik)",
        "description": "Saptashrungi Temple, located near Nashik, is considered the 'half' Shakti Peetha in the concept of Sade Teen Shakti Peethas. The temple is dedicated to Goddess Saptashrungi, and it is known for its stunning location atop a mountain, offering breathtaking views of the surrounding area."
    },
    {
        "title": "Saptashrungi Gad (Nashik)",
        "description": "Saptashrungi Gad is a famous pilgrimage destination in Maharashtra, where the goddess's half body is believed to have fallen. It is located on a hilltop, and visitors must climb hundreds of steps to reach the temple, which is an experience in itself."
    }
],

"services": [
    {
        "name": "Pune to Sade Teen Shakti Peeth Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services from Pune to the Sade Teen Shakti Peeth. Visit these sacred temples with ease and comfort, guided by our experienced drivers."
    },
    {
        "name": "Book Pune to Sade Teen Shakti Peeth Taxi",
        "description": "Book your taxi from Pune to Sade Teen Shakti Peeth with Mauli Cabs. We provide seamless booking and reliable services to ensure a peaceful pilgrimage to the Shakti Peeth."
    },
    {
        "name": "Affordable Pune to Sade Teen Shakti Peeth Cab",
        "description": "Mauli Cabs provides affordable taxi services from Pune to Sade Teen Shakti Peeth. Travel comfortably and within budget to visit these divine temples."
    },
    {
        "name": "Private Taxi for Sade Teen Shakti Peeth from Pune",
        "description": "Travel privately to Sade Teen Shakti Peeth from Pune with Mauli Cabs. We offer personalized services to make your journey peaceful and smooth."
    },
    {
        "name": "Sade Teen Shakti Peeth Pilgrimage by Cab from Pune",
        "description": "Mauli Cabs offers convenient and reliable taxi services for your pilgrimage to Sade Teen Shakti Peeth. Visit the sacred temples with a professional driver and enjoy a smooth, comfortable journey."
    },
    {
        "name": "Pune to Sade Teen Shakti Peeth One-Way or Round Trip",
        "description": "Mauli Cabs offers one-way or round-trip taxi options for your Pune to Sade Teen Shakti Peeth journey. Choose the service that best fits your schedule and travel preferences."
    },
    {
        "name": "Comfortable Taxi Ride to Sade Teen Shakti Peeth",
        "description": "Experience a comfortable taxi ride from Pune to Sade Teen Shakti Peeth with Mauli Cabs. Our well-maintained vehicles ensure you travel in peace and comfort throughout the journey."
    },
    {
        "name": "Group Travel to Sade Teen Shakti Peeth",
        "description": "Mauli Cabs provides spacious vehicles for group travel to Sade Teen Shakti Peeth. Whether you're traveling with family or a group of devotees, we ensure a comfortable and enjoyable journey for all."
    },
    {
        "name": "Luxury Cab for Sade Teen Shakti Peeth Tour",
        "description": "Travel in luxury to Sade Teen Shakti Peeth from Pune with Mauli Cabs' premium taxi services. Enjoy a plush and stylish ride with high-end amenities and excellent customer service."
    }
],

"tableData": [
    ["Pune to Sade Teen Shakti Peeth Cab Service", "Book Pune to Sade Teen Shakti Peeth Taxi"],
    ["Affordable Pune to Sade Teen Shakti Peeth Cab", "Private Taxi for Sade Teen Shakti Peeth from Pune"],
    ["Sade Teen Shakti Peeth Pilgrimage by Cab from Pune", "Pune to Sade Teen Shakti Peeth One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Sade Teen Shakti Peeth", "Group Travel to Sade Teen Shakti Peeth"],
    ["Luxury Cab for Sade Teen Shakti Peeth Tour", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and punctual service for your Pune to Sade Teen Shakti Peeth journey. Our experienced drivers ensure timely pickups and drop-offs, allowing you to visit these sacred sites without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Sade Teen Shakti Peeth trip, we offer a variety of comfortable vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned and spacious, ensuring you travel in comfort during this spiritually enriching journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are well-versed with the routes to the Sade Teen Shakti Peeths. They ensure a smooth, safe, and hassle-free trip while adhering to the best driving practices, so you can focus on your pilgrimage."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for your Pune to Sade Teen Shakti Peeth Cab journey. We ensure clear, upfront pricing with no hidden charges, so you can enjoy your journey without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are well-maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers strictly follow safety protocols to ensure a secure and comfortable journey to the Shakti Peeths."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Sade Teen Shakti Peeth trip. Whether you're starting early in the morning or returning late at night, our customer service team is always available to assist you with your booking."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Sade Teen Shakti Peeth Cab with Mauli Cabs is quick and simple. You can book online through our website or mobile app, or contact our customer service team for personalized assistance and planning."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you’re visiting one or all of the Sade Teen Shakti Peeths, Mauli Cabs offers customized travel packages for your journey. Share your preferences with us, and we will tailor your trip to make it spiritually fulfilling and convenient."
    }
]















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Sade Teen Shakti Peeth with Mauli Cabs?',
            answer: 'Booking your cab for Sade Teen Shakti Peeth is easy! You can book directly through our website or mobile app. Simply enter Pune as your pickup location and Sade Teen Shakti Peeth as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our customer support team for booking assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Sade Teen Shakti Peeth trip?',
            answer: 'Mauli Cabs offers a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose the vehicle that fits your comfort, group size, and budget for the pilgrimage trip.',
        },
        {
            question: 'Is the fare for the Pune to Sade Teen Shakti Peeth trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. The total fare includes tolls, taxes, and driver charges, ensuring there are no hidden costs. You will know the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Sade Teen Shakti Peeth take?',
            answer: 'The journey from Pune to Sade Teen Shakti Peeth typically takes around 6 to 7 hours, depending on the traffic and road conditions. Our drivers ensure a smooth, comfortable, and timely journey for you.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Sade Teen Shakti Peeth route?',
            answer: 'Yes, Mauli Cabs drivers are well-experienced with the best routes to Sade Teen Shakti Peeth. They ensure a safe and smooth ride, taking you to the sacred places with ease.',
        },
        {
            question: 'Can I book a round trip from Pune to Sade Teen Shakti Peeth?',
            answer: 'Yes, you can book a round-trip ride. Just provide your return details when booking, and we will make sure you have a comfortable trip back to Pune.',
        },
        {
            question: 'Can I stop for sightseeing along the way to Sade Teen Shakti Peeth?',
            answer: 'Yes, you can customize your journey and make stops for sightseeing along the way. Whether you want to explore other sacred places or take a short break, we can tailor the trip to suit your preferences.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and maintained for cleanliness and comfort. We ensure a pleasant and peaceful ride for your spiritual journey to Sade Teen Shakti Peeth.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is available to assist you at any time.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Sade Teen Shakti Peeth trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and timely service. Whether for a peaceful pilgrimage or a family trip, we ensure a comfortable and hassle-free journey to Sade Teen Shakti Peeth.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Subhash Deshmukh",
            position: "Devotee",
            text: "The trip to Sade Teen Shakti Peeth with Mauli Cabs was absolutely serene. The driver was knowledgeable about the routes and the sacred places, making the journey smooth and peaceful. The vehicle was comfortable, and the whole experience was spiritual and stress-free.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Patil",
            position: "Spiritual Traveler",
            text: "I had a beautiful and spiritual trip to Sade Teen Shakti Peeth with Mauli Cabs. The driver was very respectful and accommodating. The journey was smooth, and the vehicle was clean and comfortable. I highly recommend Mauli Cabs for this sacred journey!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Sade Teen Shakti Peeth Cab by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and comfortable cab services from Pune to Sade Teen Shakti Peeth pilgrimage sites. Choose from private, luxury, or group taxis for one-way or round-trip journeys. Enjoy a smooth and hassle-free journey to these sacred temples with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "4000"
        }
      };
      
     
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Sade Teen Shakti Peeth Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Sade Teen Shakti Peeth pilgrimage cab with Mauli Cabs. Affordable and comfortable private, luxury, and group taxi options are available for one-way or round-trip travel. Experience a hassle-free journey with 24x7 online booking."
        />
        <meta
          name="keywords"
          content="Pune to Sade Teen Shakti Peeth cab service, Book Pune to Sade Teen Shakti Peeth taxi, Affordable Pune to Sade Teen Shakti Peeth cab, Private taxi for Sade Teen Shakti Peeth from Pune, Sade Teen Shakti Peeth pilgrimage by cab from Pune, Pune to Sade Teen Shakti Peeth one-way or round trip, Comfortable taxi ride to Sade Teen Shakti Peeth, Group travel to Sade Teen Shakti Peeth, Luxury cab for Sade Teen Shakti Peeth tour"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosaneteenshaktipeeth;